import { Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonFiles from "src/components/UI/buttons/ButtonFile";
import DropZone from "src/components/UI/Dropzone";
import { useToast } from "src/hooks/useToast";
import { changeDescriptionErrors, setDescriptionData, setNamePicture } from "src/store/stockpile/createServiceForm";
import { setCheckItemFormAlert } from "src/store/stockpile/RecursosVisualeSlice";
import { RootState } from "src/store/store";
import { toBase64 } from "src/util/converToBase64";
import InputFloatingLabel from '../../../UI/forms/InputFloatingLabel';
import TextArea from '../../../UI/forms/TextArea';
import GeneralRatesSchema from './validations'


interface Props {
  alertComplete: any
}

const Description: React.FC<Props> = (props: Props) => {
  const toast = useToast()
  const dispatch = useDispatch()

  const Data: any = useSelector((state: RootState) => state.createServiceForm.Description)

  const NameFile: any = useSelector((state: RootState) => state.createServiceForm.namePicture)

  const [errorpictureSelected, setErrorPictureSelected] = useState<any>('')
  const [fileReceipt, setFileReceipt] = useState<any>([])
  const [viewCropper, setviewcropper] = useState<any>(false)


  const handlePicture = async (e: any) => {
    setFileReceipt(e)
    const file = e[0]

    setErrorPictureSelected(false)
    dispatch(setNamePicture(file.name))
    e[0] && setviewcropper(true)

  }



  const formik = useFormik({
    initialValues: {
      ...Data
    },
    onSubmit: () => {

    },
    validationSchema: GeneralRatesSchema
  })

  const { errors, values, handleSubmit, setFieldValue, touched } = formik

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      dispatch(setCheckItemFormAlert(false))
    }
  }, [errors])

  useEffect(() => {
    if (props.alertComplete) {
      setFieldValue('name', '')
      toast.error('Complete the required fields')
    }
  }, [props.alertComplete])

  useEffect(() => {
  }, [Data])

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      dispatch(changeDescriptionErrors(true))
    } else {
      dispatch(changeDescriptionErrors(false))
    }
  }, [errors])


  return (
    <div className="container-fluid px-3 mt-3">
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate >
          <div className="row">
            <div className="col-sm-12 col-lg-6 col-md-12">
              <InputFloatingLabel
                placeHolder="Service name"
                value={Data.name}
                onChange={(value) => {
                  dispatch(setDescriptionData({ ...Data, name: value }))
                  setFieldValue('name', value)
                }}
                isRequired
                errorMessage={errors.name}
              />
            </div>

            <div className="col-sm-12 col-lg-6 col-md-12 mb-4">
              <p className=' text-primary typo-body p-0'>SELECT PICTURE</p>
              <DropZone
                setFile={handlePicture}
                files={fileReceipt}
                maxFiles={1}
                errors={errorpictureSelected}
                vieCropper={viewCropper}
                setvieCropper={setviewcropper}
                setImage={
                  (value:any) => dispatch(setDescriptionData({ ...Data, picture: value }))
                }
              />
            </div>
            <div className="col-sm-12 col-lg-6 col-md-12">
              <InputFloatingLabel
                placeHolder="Skillsets"
                onChange={(value) => {
                  dispatch(setDescriptionData({ ...Data, skill_sets: value }))
                  setFieldValue('skill_sets', value)
                }}
                value={Data.skill_sets}
                isRequired
                errorMessage={errors.skill_sets}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col">
              <TextArea
                title="Description"
                placeHolder="Type here..."
                value={Data.description}
                onChange={(value) => {
                  dispatch(setDescriptionData({ ...Data, description: value }))
                }}
              />
            </div>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
};

export default Description;
